"use strict";

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty2(exports, "__esModule", {
  value: true
});
exports.importDateFnsLocale = importDateFnsLocale;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/promise"));
var _weakMap = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/weak-map"));
var _defineProperty = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/define-property"));
var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptor"));
function _getRequireWildcardCache(e) { if ("function" != typeof _weakMap.default) return null; var r = new _weakMap.default(), t = new _weakMap.default(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _defineProperty.default && _getOwnPropertyDescriptor.default; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? (0, _getOwnPropertyDescriptor.default)(e, u) : null; i && (i.get || i.set) ? (0, _defineProperty.default)(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Gets the import function for a specific locale.
 *
 * @param {string} langCode - The language code for the desired locale.
 *                            This can be in the format of 'en', 'en-US', 'fr-CA', etc.
 *
 * @returns {Promise<{ default: Locale }>} A promise that resolves to an object containing
 *                                        the default export of the locale module.
 *
 * @throws {Error} Implicitly throws an error if the import fails or if the locale is not supported.
 *
 * @example
 * // Import the French locale
 * const frLocale = await getLocaleImport('fr');
 *
 * @example
 * // Import the Canadian French locale
 * const frCALocale = await getLocaleImport('fr-CA');
 */
function importDateFnsLocale(langCode) {
  switch (langCode) {
    // Afrikaans
    case 'af':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-af" */'date-fns/locale/af')));
    // Arabic
    case 'ar':
    case 'ar-SA':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-ar-SA" */'date-fns/locale/ar-SA')));
    case 'ar-DZ':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-ar-DZ" */'date-fns/locale/ar-DZ')));
    case 'ar-MA':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-ar-MA" */'date-fns/locale/ar-MA')));
    // Azerbaijani
    case 'az':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-az" */'date-fns/locale/az')));
    // Belarusian
    case 'be':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-be" */'date-fns/locale/be')));
    // Bulgarian
    case 'bg':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-bg" */'date-fns/locale/bg')));
    // Bengali
    case 'bn':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-bn" */'date-fns/locale/bn')));
    // Bosnian
    case 'bs':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-bs" */'date-fns/locale/bs')));
    // Catalan
    case 'ca':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-ca" */'date-fns/locale/ca')));
    // Czech
    case 'cs':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-cs" */'date-fns/locale/cs')));
    // Welsh
    case 'cy':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-cy" */'date-fns/locale/cy')));
    // Danish
    case 'da':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-da" */'date-fns/locale/da')));
    // German
    case 'de':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-de" */'date-fns/locale/de')));
    case 'de-AT':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-de-AT" */'date-fns/locale/de-AT')));
    // Greek
    case 'el':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-el" */'date-fns/locale/el')));
    // English
    case 'en':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-en-US" */'date-fns/locale/en-US')));
    case 'en-AU':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-en-AU" */'date-fns/locale/en-AU')));
    case 'en-CA':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-en-CA" */'date-fns/locale/en-CA')));
    case 'en-GB':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-en-GB" */'date-fns/locale/en-GB')));
    case 'en-IE':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-en-IE" */'date-fns/locale/en-IE')));
    case 'en-IN':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-en-IN" */'date-fns/locale/en-IN')));
    case 'en-NZ':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-en-NZ" */'date-fns/locale/en-NZ')));
    case 'en-ZA':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-en-ZA" */'date-fns/locale/en-ZA')));
    // Esperanto
    case 'eo':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-eo" */'date-fns/locale/eo')));
    // Spanish
    case 'es':
    case 'es-419':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-es" */'date-fns/locale/es')));
    // Estonian
    case 'et':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-et" */'date-fns/locale/et')));
    // Basque
    case 'eu':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-eu" */'date-fns/locale/eu')));
    // Persian
    case 'fa':
    case 'fa-IR':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-fa-IR" */'date-fns/locale/fa-IR')));
    // Finnish
    case 'fi':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-fi" */'date-fns/locale/fi')));
    // French
    case 'fr':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-fr" */'date-fns/locale/fr')));
    case 'fr-CA':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-fr-CA" */'date-fns/locale/fr-CA')));
    case 'fr-CH':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-fr-CH" */'date-fns/locale/fr-CH')));
    // Galician
    case 'gl':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-gl" */'date-fns/locale/gl')));
    // Gujarati
    case 'gu':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-gu" */'date-fns/locale/gu')));
    // Hebrew
    case 'he':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-he" */'date-fns/locale/he')));
    // Hindi
    case 'hi':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-hi" */'date-fns/locale/hi')));
    // Croatian
    case 'hr':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-hr" */'date-fns/locale/hr')));
    // Hungarian
    case 'hu':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-hu" */'date-fns/locale/hu')));
    // Armenian
    case 'hy':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-hy" */'date-fns/locale/hy')));
    // Indonesian
    case 'id':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-id" */'date-fns/locale/id')));
    // Icelandic
    case 'is':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-is" */'date-fns/locale/is')));
    // Italian
    case 'it':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-it" */'date-fns/locale/it')));
    case 'it-CH':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-it-CH" */'date-fns/locale/it-CH')));
    // Japanese
    case 'ja':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-ja" */'date-fns/locale/ja')));
    case 'ja-Hira':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-ja-Hira" */'date-fns/locale/ja-Hira')));
    // Georgian
    case 'ka':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-ka" */'date-fns/locale/ka')));
    // Kazakh
    case 'kk':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-kk" */'date-fns/locale/kk')));
    // Khmer
    case 'km':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-km" */'date-fns/locale/km')));
    // Kannada
    case 'kn':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-kn" */'date-fns/locale/kn')));
    // Korean
    case 'ko':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-ko" */'date-fns/locale/ko')));
    // Lithuanian
    case 'lt':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-lt" */'date-fns/locale/lt')));
    // Latvian
    case 'lv':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-lv" */'date-fns/locale/lv')));
    // Macedonian
    case 'mk':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-mk" */'date-fns/locale/mk')));
    // Mongolian
    case 'mn':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-mn" */'date-fns/locale/mn')));
    // Malay
    case 'ms':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-ms" */'date-fns/locale/ms')));
    // Dutch
    case 'nl':
    case 'nl-NL':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-nl" */'date-fns/locale/nl')));
    case 'nl-BE':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-nl-BE" */'date-fns/locale/nl-BE')));
    // Norwegian Bokmål
    case 'nb':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-nb" */'date-fns/locale/nb')));
    // Norwegian Nynorsk
    case 'nn':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-nn" */'date-fns/locale/nn')));
    // Polish
    case 'pl':
    case 'pl-PL':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-pl" */'date-fns/locale/pl')));
    // Portuguese
    case 'pt':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-pt" */'date-fns/locale/pt')));
    case 'pt-BR':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-pt-BR" */'date-fns/locale/pt-BR')));
    // Romanian
    case 'ro':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-ro" */'date-fns/locale/ro')));
    // Russian
    case 'ru':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-ru" */'date-fns/locale/ru')));
    // Slovak
    case 'sk':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-sk" */'date-fns/locale/sk')));
    // Slovenian
    case 'sl':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-sl" */'date-fns/locale/sl')));
    // Serbian
    case 'sr':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-sr" */'date-fns/locale/sr')));
    case 'sr-Latn':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-sr-Latn" */'date-fns/locale/sr-Latn')));
    // Swedish
    case 'sv':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-sv" */'date-fns/locale/sv')));
    // Tamil
    case 'ta':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-ta" */'date-fns/locale/ta')));
    // Telugu
    case 'te':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-te" */'date-fns/locale/te')));
    // Thai
    case 'th':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-th" */'date-fns/locale/th')));
    // Turkish
    case 'tr':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-tr" */'date-fns/locale/tr')));
    // Ukrainian
    case 'uk':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-uk" */'date-fns/locale/uk')));
    // Uzbek
    case 'uz':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-uz" */'date-fns/locale/uz')));
    case 'uz-Cyrl':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-uz-Cyrl" */'date-fns/locale/uz-Cyrl')));
    // Vietnamese
    case 'vi':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-vi" */'date-fns/locale/vi')));
    // Chinese
    case 'zh':
    case 'zh-CN':
    case 'zh-Hans-CN':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-zh-CN" */'date-fns/locale/zh-CN')));
    case 'zh-HK':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-zh-HK" */'date-fns/locale/zh-HK')));
    case 'zh-TW':
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-zh-TW" */'date-fns/locale/zh-TW')));
    // Default to English US
    default:
      return _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-en-US" */'date-fns/locale/en-US')));
  }
}